import { FileUp } from 'lucide-react';
import { AvatarNameDescription } from '../../../../design-system/avatar/avatar-name-description/avatar-name-description';
import { Inline } from '../../../../design-system/inline/inline';
import { getAmountWithCurrency } from '../../../../utils/get-amount-with-currency';
import { isSupportedCurrency } from '../../../payments/utils/is-supported-currency';
import { getInvoiceDateCellContent } from './to-pay-invoice-table-columns-definition';

type InvoiceCardProps = {
  invoiceDate?: Date;
  vendorName: string;
  invoiceReference: string;
  amount?: number;
  currency?: string;
};

export const InvoiceCard = ({ invoiceDate, vendorName, invoiceReference, amount, currency }: InvoiceCardProps) => {
  const formattedDate = getInvoiceDateCellContent(invoiceDate);
  const formattedAmount =
    isSupportedCurrency(currency) && amount
      ? getAmountWithCurrency({
          amount,
          currency,
          isAccountBalance: true,
        })
      : '—';

  return (
    <Inline justify="between" className="rounded-lg bg-muted px-5 py-4">
      <Inline wrap="nowrap" justify="between" space={12}>
        <p className="text-sm leading-6 font-normal tracking-tight text-nowrap text-black">{formattedDate}</p>

        <AvatarNameDescription
          avatar={{ showAvatar: true }}
          name={vendorName}
          description={invoiceReference}
          descriptionIcon={<FileUp strokeWidth={1} size={16} color="#68686D" />}
        />
      </Inline>

      <p className="text-sm leading-6 font-normal tracking-tight text-black">{formattedAmount}</p>
    </Inline>
  );
};
